
/**
 * @name crud_marketing_leads.js
 * @author Fellipe Orsini
 * @package clinic-mvp\app\assets\js\crud_marketing_leads.js
 */

//import { apiCall, getBaseDir } from './utils.js';

const XLSX = require('xlsx');
var getBaseDir = null, apiCall = null, userHasRole = null;

$(function()
{
    import('../../../utils.js').then(utils => {
        getBaseDir = utils.getBaseDir;
        apiCall = utils.apiCall;
        userHasRole = utils.userHasRole;

        if (!utils.isUserLoggedIn())
            return;

        // A partir dessa parte só vai executar os códigos abaixo quando estiver na página inicial
        if (location.pathname !== utils.getBaseDir() + 'relatorios/cancelamentos')
            return;

        new CancellationReports(true, {
            getBaseDir: utils.getBaseDir,
            apiCall: utils.apiCall,
            userHasRole: utils.userHasRole,
        });
    });
});

class CancellationReports
{
    constructor(onloadList=false, deps = {})
    {
        this.deps = deps;
        this.initExport();
    }

    initExport()
    {
        $(document).on('click', '.js-export-cancellations', (e) => {
            const tbl1 = document.getElementById("table-reports-cancellations");
            const worksheet = XLSX.utils.table_to_sheet(tbl1);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
            XLSX.writeFile(workbook, 'relatorio_cancelamentos_'+window.getSaoPauloDateTime()+'.xlsx');
            window.toast({
                error: false,
                text: "Exportação realizada com sucesso."
            })
        });
    }
}
